"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Pagination = _styledComponents["default"].ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .page-item {\n        &:first-child {\n            .page-link {\n                padding-left: 0;\n            }\n        }\n        &:last-child {\n            .page-link {\n                padding-right: 0;\n            }\n        }\n\n        &.active {\n            .page-link {\n                color: ", ";\n                text-decoration: underline;\n            }\n        }\n\n        .page-link {\n            background-color: transparent;\n            border: none;\n            padding: 0 0.3rem;\n            &:active,\n            &:focus {\n                outline: none;\n                box-shadow: none;\n            }\n\n            &.disabled {\n                background-color: transparent;\n                color: ", ";\n            }\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.font.color;
});

exports.Pagination = Pagination;